import { render, staticRenderFns } from "./LeaveView.vue?vue&type=template&id=9858335c&scoped=true&"
import script from "./LeaveView.vue?vue&type=script&lang=js&"
export * from "./LeaveView.vue?vue&type=script&lang=js&"
import style0 from "./LeaveView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LeaveView.vue?vue&type=style&index=1&id=9858335c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9858335c",
  null
  
)

export default component.exports